import { PenLine, ArrowUp, Linkedin } from "lucide-react";
import { EMAIL, LINKEDIN, MARQUEE_ITEMS } from "@/data/content";

export const Footer = () => {
  return (
    <footer className="bg-ink text-paper" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 sm:px-12 lg:px-20 py-16 sm:py-20">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-10 border-b border-paper/15 pb-12">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.24em] text-amber mb-4">Colophon</p>
            <h2 className="font-serif text-4xl sm:text-5xl tracking-tight leading-[1.08]">
              Melinda <em className="text-amber/90">Adams</em>
            </h2>
            <p className="mt-4 font-serif italic text-lg text-paper/60 max-w-md">
              Copy that helps the audience recognize a need, understand a product, and feel ready for the next step.
            </p>
          </div>
          <button
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
            className="group inline-flex items-center gap-3 font-mono text-[11px] uppercase tracking-[0.2em] text-paper/70 hover:text-amber transition-colors duration-300 self-start lg:self-auto"
            data-testid="back-to-top-button"
          >
            Back to the top
            <span className="w-10 h-10 rounded-full border border-paper/25 flex items-center justify-center transition-colors duration-300 group-hover:border-amber">
              <ArrowUp size={16} className="transition-transform duration-300 group-hover:-translate-y-0.5" />
            </span>
          </button>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row justify-between gap-6">
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            {MARQUEE_ITEMS.slice(0, 5).map((s) => (
              <span key={s} className="font-mono text-[10px] uppercase tracking-[0.18em] text-paper/50">{s}</span>
            ))}
          </div>
          <div className="flex flex-wrap items-center gap-6">
            <a href={`mailto:${EMAIL}`} className="font-mono text-[11px] tracking-[0.08em] text-amber hover:text-paper transition-colors duration-300" data-testid="footer-email-link">
              {EMAIL}
            </a>
            <a href={LINKEDIN} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 font-mono text-[11px] tracking-[0.08em] text-amber hover:text-paper transition-colors duration-300" data-testid="footer-linkedin-link">
              <Linkedin size={13} /> LinkedIn
            </a>
          </div>
        </div>

        <div className="mt-10 flex items-center justify-between border-t border-paper/15 pt-8">
          <div className="flex items-center gap-3">
            <span className="w-7 h-7 rounded-full bg-amber text-ink flex items-center justify-center">
              <PenLine size={12} />
            </span>
            <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-paper/50">
              Set in Cormorant Garamond &amp; Plus Jakarta Sans
            </span>
          </div>
          <span className="font-mono text-[10px] uppercase tracking-[0.18em] text-paper/50">© 2026</span>
        </div>
      </div>
    </footer>
  );
};
